import { Grid, IconButton, Typography } from "@mui/material"
import React, { MouseEvent, useCallback, useContext, useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { customPalette } from "../../../../../../../theme"
import { SquareBadge } from "../../../../../../components/badges/SquareBadge"
import { IconListCheck } from "../../../../../../components/custom-icons/IconListCheck"
import { pagesUrl } from "../../../../../../core/appConstants"
import { ProjectContext } from "../../../../../../core/context/project/ProjectContext"
import { BSBimModel } from "../../../../../../core/dto/beem-shot/BSBimModel/BSBimModel"
import { formatToFrench } from "../../../../../../core/services/date-service"
import { greySelectableStyle } from "../../../../../../core/services/helper-service"
import { resolveUrl } from "../../../../../../core/services/http-service"
import { BSDeleteBimModelButton } from "../../../beem-shot/variant/components/BSDeleteBimModelButton/BSDeleteBimModelButton"

interface IProps {
  bsBimModel: BSBimModel
}

export function BSBimModelRow({ bsBimModel }: Readonly<IProps>): React.JSX.Element {
  const navigate = useNavigate()
  const location = useLocation()

  const { project } = useContext(ProjectContext)

  const rowSelectableStyle = useMemo(() => greySelectableStyle(false), [])

  const navigateToUpdateModel: (event: MouseEvent<any>) => void = useCallback(
    (event) => {
      event.stopPropagation()
      navigate(resolveUrl(pagesUrl.BIM_MODEL_IMPORT_PAGE, [project?.id, bsBimModel?.id]), {
        state: { from: location.pathname },
      })
    },
    [bsBimModel?.id, location.pathname, navigate, project?.id]
  )

  const navigateToBimModelDetail: (event: React.MouseEvent<any>) => void = useCallback(
    (event) => {
      event.stopPropagation()
      navigate(resolveUrl(pagesUrl.BIM_MODEL_DETAIL_PAGE, [project?.id, bsBimModel?.id]), {
        state: { from: location.pathname },
      })
    },
    [bsBimModel?.id, location.pathname, navigate, project?.id]
  )

  return (
    <Grid
      item
      xs={12}
      container
      py={2}
      borderRadius={3}
      alignItems="center"
      p={1}
      boxShadow={5}
      onClick={navigateToUpdateModel}
      columnSpacing={1}
      sx={{ background: customPalette.white, ...rowSelectableStyle }}>
      <Grid item xs={4}>
        <Typography variant="body2" sx={{ overflow: "hidden" }}>
          {bsBimModel.fileName}
        </Typography>
      </Grid>

      <Grid item xs={3}>
        <Typography variant="body2"> {formatToFrench(bsBimModel.createdDate)}</Typography>
      </Grid>

      <Grid item xs={2}>
        <Typography variant="body2"> {bsBimModel.surfacePlancher}</Typography>
      </Grid>

      <Grid item xs={2}>
        <SquareBadge
          backgroundColor={bsBimModel.variantCount === 0 ? customPalette.lightblue20 : customPalette.lightBlue5}
          color={bsBimModel.variantCount === 0 ? customPalette.lightBlue5 : customPalette.white}
          content={bsBimModel.variantCount}
          cursor="pointer"
        />
      </Grid>

      {/*TODO: hidden while there is no page with bim model import warnings*/}
      {/*<Grid item xs={2}>*/}
      {/*  <SquareBadge*/}
      {/*    backgroundColor={customPalette.backgroundLightRed}*/}
      {/*    color={customPalette.redWrongValue}*/}
      {/*    content={0}*/}
      {/*    cursor="pointer"*/}
      {/*  />*/}
      {/*</Grid>*/}

      <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
        <IconButton onClick={navigateToBimModelDetail}>
          <IconListCheck sx={{ color: customPalette.subtitleGray }} />
        </IconButton>
        <BSDeleteBimModelButton bsBimModelToDelete={bsBimModel} />
      </Grid>
    </Grid>
  )
}
